import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/addMonths/index.js';

var require$$10 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$10 as default };
